<template>
<div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
        <v-layout row wrap justify-center>
            <v-flex xs12>
                <app-card>
                    <app-section-loader :status="loading.getListContracts"></app-section-loader>
                    <v-card-title>
                        <v-layout row>
                            <v-flex auto class="pa-0">
                                <h4>BẢNG HỢP ĐỒNG THUÊ PHÒNG</h4>
                            </v-flex>
                            <v-spacer></v-spacer>
                        </v-layout>
                        <v-layout row justify-end>
                            <v-flex xs12 md3>
                                <v-select
                                    label="Tòa nhà"
                                    :disabled="loading.submit"
                                    v-model="chosen_building"
                                    :items="list_building"
                                    prepend-icon="domain"
                                    required
                                    single-line
                                    hide-details
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field
                                v-model="search"
                                prepend-icon="search"
                                label="Tìm kiếm"
                                single-line
                                hide-details
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-select
                                    label="Tìm theo"
                                    :disabled="loading.submit"
                                    v-model="search_type"
                                    :items="list_search_type"
                                    prepend-icon="visibility"
                                    required
                                    single-line
                                    hide-details
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md3 class="pb-0">
                                <v-btn @click="getTablesData" color="primary" dark class="mt-3 mb-0">
                                    Tìm kiếm
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card class="mt-4">
                        <v-data-table
                            :headers="headers"
                            :items="items"
                            :rows-per-page-items="rowPerPage"
                            disable-initial-sort
                            :loading="loading.getListContracts"
                        >
                            <template #headers="props">
                                <tr>
                                    <th :class="`text-xs-${header.align} fw-bold`" v-for="header in props.headers" :key="header.text">
                                        {{ header.text }}
                                    </th>
                                </tr>
                            </template>
                        <template #items="props">
                            <tr style="cursor: pointer" @click="showDetail(props.item)">
                                <td class="text-center">{{ props.item.room_id }}</td>
                                <td class="text-left text-no-wrap">{{ props.item.name }}</td>
                                <td class="text-center">{{ props.item.room_price | formatNumber }}</td>
                                <td class="text-center">{{ props.item.deposit_price | formatNumber }}</td>
                                <td class="text-center">{{ props.item.customer_count }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.date_in | formatTimeServer }}</td>
                                <td class="text-center">{{ props.item.water_price | formatNumber }}</td>
                                <td class="text-center">{{ props.item.trash_price | formatNumber }}</td>
                                <td class="text-center">{{ props.item.internet_price | formatNumber }}</td>
                                <td class="text-center">{{ props.item.motorbike_count }}</td>
                                <td class="text-center">{{ props.item.bike_count }}</td>
                                <!-- <td class="text-center">{{ props.item.parking_price | formatNumber }}</td> -->
                                <td class="text-center">{{ props.item.washing_machine_price | formatNumber }}</td>
                                <td class="text-center">{{ props.item.air_conditioner_price | formatNumber }}</td>
                            </tr>
                        </template>
                        </v-data-table>
                    </v-card>
                </app-card>
            </v-flex>
        </v-layout>
    </v-container>
    <v-dialog v-model="dialogDetail" max-width="80%">
        <app-card>
            <app-section-loader :status="loading.getDetail"></app-section-loader>
            <h4 class="mb-4 mt-2">Chi tiết phòng số: {{ chosen_contract.room_id }}</h4>
            <v-data-table :headers="detail_headers" :items="chosen_contract.customers" item-key="id">
                <template #headers="props">
                    <tr>
                        <th class="text-xs-center fw-bold" v-for="header in props.headers" :key="header.text">
                            {{ header.text }}
                        </th>
                    </tr>
                </template>
                <template #items="props">
                    <tr>
                        <td class="text-center text-no-wrap">{{ props.item.name }}</td>
                        <td class="text-center text-no-wrap">{{ props.item.phone }}</td>
                        <td class="text-center text-no-wrap">{{ props.item.motorbike ? props.item.motorbike : 'Không có' }}</td>
                        <td class="text-center text-no-wrap">{{ props.item.bike ? 'Có' : 'Không có' }}</td>
                    </tr>
                </template>
            </v-data-table>
        </app-card>
    </v-dialog>
</div>
</template>

<script>
import api from "../../api";
import moment from 'moment'
import { buildParamQuery, formatTimeServer } from '../../helpers/helpers.js'
import { list_building } from '../../constants/db-config'

export default {
    name: 'contract',
    data() {
        return {
            search:'',
            search_type: 'roomId',
            headers: [
                { text: "Số phòng", align: "center", sortable: false, value: "room_id" },
                // { text: "Mã khách hàng", align: "center", value: "customer_code" },
                { text: "Họ và tên", align: "left", value: "name" },
                { text: "Đơn giá", align: "center", value: "room_price" },
                { text: "Tiền cọc", align: "center", value: "deposit" },
                { text: "Số người ở", align: "center", value: "customer_count" },
                { text: "Ngày dọn vào", align: "center", value: "date_in" },
                { text: "Tiền nước", align: "center", value: "water_price" },
                { text: "Tiền rác", align: "center", value: "trash_price" },
                { text: "Tiền Internet", align: "center", value: "internet_price" },
                { text: "Số lượng xe máy", align: "center", value: "motorbike_count" },
                { text: "Số lượng xe đạp", align: "center", value: "bike_count" },
                // { text: "Tiền gửi xe", align: "center", value: "parking_price" },
                { text: "Máy giặt", align: "center", value: "washing_machine_price" },
                { text: "Máy lạnh", align: "center", value: "air_conditioner_price" },
            ],
            detail_headers: [
                { text: "Tên", align: "center", sortable: false, value: "name" },
                { text: "SDT", align: "center", sortable: false, value: "name" },
                { text: "Xe máy", align: "center", sortable: false, value: "motorbike" },
                { text: "Xe đạp", align: "center", sortable: false, value: "bike" }
            ],
            list_building: [
                ...list_building,
                {text: 'Tất cả', value: ''},
            ],
            list_search_type: [
                { text: 'Số phòng', value: 'roomId' },
                { text: 'Tên khách hàng', value: 'name' },
                { text: 'Biển số xe', value: 'motorbike' }
            ],
            chosen_building: 'BN',
            items: [],
            loading: {
                submit: false,
                getDetail: false,
                getListContracts: false
            },
            rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}],
            dialogDetail: false,
            chosen_contract: {},
        };
    },
    mounted() {
        this.getTablesData();
    },
    methods: {
        getTablesData: async function () {
            this.loading.getListContracts = true
            const params = {
                building: this.chosen_building,
                [this.search_type]: this.search,
                contractValid: true
            }
            const query = buildParamQuery(params)
            let data = await api.getListContracts(query)
            this.loading.getListContracts = false
            this.items = data.data.contracts.map( contract => this.handleData(contract))
        },
        handleData: function (data){
            data.customer_count = data.listCustomers.length
            data.motorbike_count = data.devicesInfo.filter( device => device.type === 'MB').length
            data.bike_count = data.devicesInfo.filter( device => device.type === 'B').length
            data.customers = data.listCustomers.map( customer => {
                const motorbike = data.devicesInfo.find(device => device.type === 'MB' && device.customer_id === customer.customer_id )
                const bike = data.devicesInfo.find(device => device.type === 'B' && device.customer_id === customer.customer_id )
                customer.bike = !!bike
                customer.motorbike = motorbike ? motorbike.name : false
                return customer
            })
            const internet = data.devicesInfo.find( device => device.type === 'INTERNET')
            data.internet_price = internet ? internet.price : 0 
            return data
        },
        showDetail: async function (contract){
            this.dialogDetail = true
            // this.loading.getDetail = true
            // let data = await api.searchCustomer( 'contractId=' + contract._id )
            // this.loading.getDetail = false
            // contract.customers = data.data.slice(0)
            this.chosen_contract = contract
        }
    }
};
</script>
